export const IDLE_THRESHOLD = 3600

export const stateDisplays = {
  IDL: 'Idle',
  CON: 'Connecting',
  HET: 'Heating',
  WHE: 'Wait heating',
  COL: 'Cooling',
  TIM: 'Timer',
  ALM: 'Alarm',
  STP: 'Stopped',
  RDY: 'Ready',
  CXP: 'Connection expired',
  ALH: 'Alarm System Stopped',
  ALT: 'Temp Alarm',
  ALR: 'No Reach Alarm',
  ALC: 'No Connection Alarm',
}

export const icons = {
  IDL: 'thermometer.png',
  COL: 'thermometer_heating.png',
  RDY: 'thermometer.png',
  WHE: 'thermometer.png',
  HET: 'thermometer_heating.png',
  TIM: 'thermometer_timer.png',
  STP: 'thermometer_alarm.png',
  CXP: 'thermometer_alarm.png',
  ALM: 'thermometer_alarm.png',
  ALH: 'thermometer_alarm.png',
  ALT: 'thermometer_alarm.png',
  ALR: 'thermometer_alarm.png',
  ALC: 'thermometer_alarm.png',
  default: 'thermometer_idle.png'
}

export const periods = {
  '30 min': [1800, '1T'],
  '1 hour': [3600, '2T'],
  '2 hours': [7200, '3T'],
  'Max': [604800, '1T'],
}

export const predictWindows = {
  '30 min': 1800,
  '1 hour': 3600,
  '2 hours': 7200,
  'Max': 86400,
}

export const clusterColors = {
  RED: "#ff474c",
  GREEN: "#c9ff27",
  BLUE: "#a2cffe",
  LOCATION: "#c79fef",
  YELLOW: "#fffe7a",
  WHITE: "#ffffff",
  BLACK: "#000000",
  HEATER: "#ff00ce",
  PWM: "#ff00ce",
  default: "#fdaa48"
}

export const locationColors = {
  FLOOR: "#ff474c",
  CONSOLE: "#c79fef",
  MOTOR: "#a2cffe",
  DASHBOARD: "#c9ff27",
  LA: "#be03fd",
  LB: "#8e82fe",
  LC: "#9a0eea",
  LD: "#b0ff9d",
  LE: "#fdaa48",
  LF: "#ffcfdc",
  LEFT: "#ceffoo",
  RIGHT: "#00ceff",
  LINKS: "#ceffoo",
  RECHTS: "#00ceff",
  CLEFT: "#ceffoo",
  CRIGHT: "#00ceff",
  FRONT: "#ceffoo",
  BACK: "#00ceff",
  VOOR: "#ceffoo",
  ACHTER: "#00ceff",
  MIDDLE: "#ceffoo",
  FRONTLEFT: "#ceffoo",
  FRONTRIGHT: "#00ceff",
  REARLEFT: "#ffce00",
  REARRIGHT: "#00ffce",
  SENSOR1: "#ceffoo",
  SENSOR2: "#00ceff",
  SENSOR3: "#ffce00",
  SENSOR4: "#00ffce",
  SENSOR5: "#ff474c",
  SENSOR6: "#a2cffe",
  default: "#fdaa48"
}

// Weather api weather condition lookup
// (taken from https://openweathermap.org/weather-conditions#How-to-get-icon-URL)
export const weatherDescriptions = {
    200: 	['Thunderstorm', 'thunderstorm with light rain',        11],
    201: 	['Thunderstorm', 'thunderstorm with rain', 	            11],
    202: 	['Thunderstorm', 'thunderstorm with heavy rain',        11],
    210: 	['Thunderstorm', 'light thunderstorm', 	                11],
    211: 	['Thunderstorm', 'thunderstorm', 	                    11],
    212: 	['Thunderstorm', 'heavy thunderstorm', 	                11],
    221: 	['Thunderstorm', 'ragged thunderstorm', 	            11],
    230: 	['Thunderstorm', 'thunderstorm with light drizzle',     11],
    231: 	['Thunderstorm', 'thunderstorm with drizzle',   	    11],
    232: 	['Thunderstorm', 'thunderstorm with heavy drizzle',     11],
    300: 	['Drizzle', 	 'light intensity drizzle',              9],
    301: 	['Drizzle', 	 'drizzle',                              9],
    302: 	['Drizzle', 	 'heavy intensity drizzle',              9],
    310: 	['Drizzle', 	 'light intensity drizzle rain',         9],
    311: 	['Drizzle', 	 'drizzle rain',                         9],
    312: 	['Drizzle', 	 'heavy intensity drizzle rain',         9],
    313: 	['Drizzle', 	 'shower rain and drizzle',              9],
    314: 	['Drizzle', 	 'heavy shower rain and drizzle',        9],
    321: 	['Drizzle', 	 'shower drizzle',                       9],
    500: 	['Rain', 	    'light rain',                           10],
    501: 	['Rain', 	    'moderate rain',                        10],
    502: 	['Rain', 	    'heavy intensity rain',                 10],
    503: 	['Rain', 	    'very heavy rain',                      10],
    504: 	['Rain', 	    'extreme rain',                         10],
    511: 	['Rain', 	    'freezing rain',                        13],
    520: 	['Rain', 	    'light intensity shower rain', 	         9],
    521: 	['Rain', 	    'shower rain',                           9],
    522: 	['Rain', 	    'heavy intensity shower rain',           9],
    531: 	['Rain', 	    'ragged shower rain',                    9],
    600: 	['Snow', 	    'light snow',                           13],
    601: 	['Snow', 	    'snow',                                 13],
    602: 	['Snow', 	    'heavy snow',                           13],
    611: 	['Snow', 	    'sleet',                                13],
    612: 	['Snow', 	    'light shower sleet',                   13],
    613: 	['Snow', 	    'shower sleet',                         13],
    615: 	['Snow', 	    'light rain and snow',                  13],
    616: 	['Snow', 	    'rain and snow',                        13],
    620: 	['Snow', 	    'light shower snow',                    13],
    621: 	['Snow', 	    'shower snow',                          13],
    622: 	['Snow', 	    'heavy shower snow',                    13],
    701: 	['Mist', 	    'mist',                        	        50],
    711: 	['Smoke', 	    'smoke',                       	        50],
    721: 	['Haze', 	    'haze',                        	        50],
    731: 	['Dust', 	    'sand/ dust whirls',           	        50],
    741: 	['Fog', 	    'fog',                                  50],
    751: 	['Sand', 	    'sand',                        	        50],
    761: 	['Dust', 	    'dust',                        	        50],
    762: 	['Ash', 	    'volcanic ash',                         50],
    771: 	['Squall', 	    'squalls',                     	        50],
    781: 	['Tornado', 	'tornado',                              50],
    800: 	['Clear',       'clear sky',                             1],
    801: 	['Clouds', 	    'few clouds',          	                 2],
    802: 	['Clouds', 	    'scattered clouds',    	                 3],
    803: 	['Clouds', 	    'broken clouds',       	                 4],
    804: 	['Clouds', 	    'overcast clouds',    	                 4],
}

export const weekdays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
